import { Banner, BannerResponse } from "../apollo/models/base-models"

export const filterBannerLicence = (banners: Banner[], licence) => {
    return banners.find(banner => {
        return banner.licence === licence
    }) || banners[0]
}